module.exports = __webpack_public_path__ + "img/default.a09db722.png";